module.exports = __webpack_public_path__ + "img/penilaian_atasan.a652d199.png";